const _ = require('lodash');

const RrPageGroupFeaturePrefix = 'rrShowPlacementsIn';
const RrPageGroupFeatureSuffix = 'Pages';

class RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService, config) {
        this.$scope = $scope;
        this.$window = $window;
        this.featureService = featureService;
        this.richRelevanceService = richRelevanceService;

        // attributes from the component.
        // each controller must declare these
        // so we can use them to decide whether to
        // add placement types.
        this.pageGroup = null;
        this.placementIds = null;

        this.initialize(_.extend(this.getDefaultConfig(), config));

    }

    getDefaultConfig() {
        return {
            // when enabled, calls the subclass implementation of
            // sendInstrumentation() when $stateChangeSuccess (ui-router)
            // occurs. Disable this if the state change isn't required or
            // the subclass implements this on its own.
            // eg: category-instrumentaion-component
            instrumentOnStateChange: true,
        };
    }

    initialize(config) {
        if (config.instrumentOnStateChange) {
            this.$scope.$on('$stateChangeSuccess', () => {
                // sub class must implement sendInstrumentaton
                // and perform the RR instrumentation call.
                this.sendInstrumentation();
            });
        }
    }

    addPlacementTypesIfEnabled() {

        this.placementTypes().forEach((placementId) => {
            this.$window.R3_COMMON.addPlacementType(placementId);
            this.richRelevanceService.recordPlacementsRequested(placementId);
        });
    }

    placementTypes() {
        if (!this.pageGroup || !this.placementIds) {
            return [];
        }

        const featureEnabled = this.pageFeatureEnabled();
        if (!featureEnabled) {
            return [];
        }

        return this.placementIds.split(',').map(placementId => this.richRelevanceService.getEffectivePlacementId(placementId.trim()));
    }

    pageFeatureEnabled() {
        // corresponding feature is [prefix][pageGroup][suffix]
        // eg: rrShowPlacementsInHomepagePages
        return this.featureService.isEnabled(this.featureService
            .features[`${RrPageGroupFeaturePrefix}${this.pageGroup}${RrPageGroupFeatureSuffix}`]);
    }

}


module.exports = RichRelevanceBaseInstrumentationController;



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-base-instrumentation-controller.js